module.exports = __webpack_public_path__ + "img/bt-4.51684140.png";